import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import addEventListener from 'rc-util/lib/Dom/addEventListener';
import * as portalactions from '../../redux/portal';

class Iframe extends Component {
  constructor(props) {
    super(props);
    const queryString = new cb.utils.queryString(props.url);
    this.state = {
      random: queryString.get('random')
    };
  }
  handleMessage(e) {
    let event = e.nativeEvent;
    if (typeof event.data !== 'object' || event.data.random !== this.state.random) return;
    if (event.data.key === 'context') {
      debugger
      this.origin = e.nativeEvent.origin;
      this.refs.iframe.contentWindow.postMessage({ key: 'params', value: cb.cache.get(event.data.random) }, this.origin);
    } else if (event.data.key === 'return') {
      debugger
      const { portalactions, index } = this.props;
      portalactions.delItem(index);
    }
  }
  componentDidMount() {
    this.messageHandler = addEventListener(window, 'message', (e) => this.handleMessage(e));
  }
  componentWillUnmount() {
    this.messageHandler.remove();
    this.messageHandler = null;
  }
  render() {
    const { url, width, height, index } = this.props;
    const style = { width, height };
    return (
      <iframe ref='iframe' id={index} name='myFrame' src={url} style={style} className='no-border' />
    );
  }
}

function mapStateToProps(state) {
  return {

  }
}

function mapDispatchToProps(dispatch) {
  return {
    portalactions: bindActionCreators(portalactions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Iframe);



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/portal/Iframe.jsx